import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import {Box, MainHeadingBig} from '../../StyledComponents';

const SummaryViewContainer = styled.div`
  /* padding-left: 5%;
  padding-right: 5%; */
  padding:0;

  @media only screen and (max-width: 991px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media only screen and (max-width: 524px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const PriceSection = styled.div`
  padding-right:0;

  ${props => props.valueFalse && css`
    color: #4a4a4a !important;

    ${SubHeading} {
      color: #4a4a4a !important;
    }

  `}
`;

const SubHeading = styled.p`
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;

  @media only screen and (max-width: 450px) {
    min-height: 30px;
  }
`;

const Label = styled.label`
  font-weight: normal;
  margin-bottom: 5px;
`;

class SummaryView extends Component {

    render() {
      const { note, reduxData, data } = this.props;
      const simulationMode = reduxData.simulationMode;

      const simulatedScore = simulationMode ? parseFloat(data.sliderValue).toFixed(1) : "N/A";
      const valueFalse = !simulationMode;

      /*
        const data = {
          "title": "Summary",
          "score": 2.9,
          "target": 6.0,
          "simulated": "N/A"
        }
      */
      const score = data && data.score && parseFloat(data.score).toFixed(1) || null;
      const target = data && data.target && parseFloat(data.target).toFixed(1) || null;


      return (
        <Box {...this.props}>
          <SummaryViewContainer>
            <MainHeadingBig>{data.name}</MainHeadingBig>
            <div className="row">
              <PriceSection valueTrue className="col-xs-4 col-sm-4 col-md-4">
                <SubHeading className="small-font-size">Relevance</SubHeading>
                <Label className="super-large-font-size ">{score || "N/A"}</Label>
              </PriceSection>

              <PriceSection valueTrue className="col-xs-4 col-sm-4 col-md-4">
                {/* <SubHeading className="small-font-size">Target relevance</SubHeading>*/}
                <SubHeading className="small-font-size">TARGET</SubHeading>
                <Label className="super-large-font-size">{target || "N/A"}</Label>
              </PriceSection>

              <PriceSection valueFalse={!simulationMode} className="col-xs-4 col-sm-4 col-md-4">
                <SubHeading className="small-font-size">Simulated</SubHeading>
                <Label className="super-large-font-size">{isNaN(simulatedScore) ? "N/A":simulatedScore}</Label>
              </PriceSection>
            </div>
          </SummaryViewContainer>
        </Box>
      );

    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        reduxData: state.data
    };
}

export default connect(mapStateToProps)(SummaryView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/SummaryView.js